import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import {
  CUSTOM_EVENTS_GRIDS,
  CUSTOM_EVENTS_TABLE_LABELS,
  CUSTOM_EVENTS_TABLE_NAMES,
} from 'modules/customEvents/constants';
import styled from 'styled-components';
import { CHECKBOX_STATUS } from 'ui/checkbox';
import { HeaderGridRow } from 'ui/indexPages/tables/grid';
import { GroupSelect } from 'ui/indexPages/tables/groupSelect';
import { button } from 'ui/theme';
import { SortableHeaderCell } from './SortableHeaderCell';

const ActionHeaderCell = styled.div`
  align-items: center;
  display: flex;
  ${button}
`;

/**
 * Table Header
 */
type CustomEventsTableHeaderRowProps = {
  checkboxStatus: CHECKBOX_STATUS;
  deselectAll: () => void;
  onSelectAll: () => void;
  sortBy: string;
  sortDirection: SORT_DIRECTIONS;
  updateSort: (name: string) => void;
};

export const CustomEventsTableHeaderRow = ({
  checkboxStatus,
  deselectAll,
  onSelectAll,
  sortBy,
  sortDirection,
  updateSort,
}: CustomEventsTableHeaderRowProps) => (
  <HeaderGridRow gridLayout={CUSTOM_EVENTS_GRIDS}>
    <ActionHeaderCell>
      <GroupSelect onSelectAll={onSelectAll} onSelectNone={deselectAll} status={checkboxStatus} />
    </ActionHeaderCell>
    {CUSTOM_EVENTS_TABLE_NAMES.map((name) => (
      <SortableHeaderCell
        key={name}
        label={CUSTOM_EVENTS_TABLE_LABELS[name]}
        name={name}
        onClick={updateSort}
        sortBy={sortBy}
        sortDirection={sortDirection}
      />
    ))}
    <ActionHeaderCell />
  </HeaderGridRow>
);
